'use strict'

module.exports = require('./lib/parser')
